import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * A hint shown to the user that they can dismiss
 *
 * A short text hint with a button allowing the user to dismiss the hint.
 * Useful to explain how to do something for the first time, but the
 * user doesn't want to see over and over again.
 *
 * This component dismisses itself Optimistically - that is, tapping the dismiss
 * button will immediately stop rendering the component, and call the
 * [onDismiss] callback.
 *
 * This component does not wait for any response from the parent.
 *
 * Typical use case is
 * 1. User reads the hint
 * 2. User taps dismiss
 * 3. The hint is no longer on the page
 * 4. The callback is used to mark the hint as seen, so that next time
 *    the hint will not be shown
 */

@Component({
  selector: 'ca-dismissible-hint',
  templateUrl: 'dismissible-hint.component.html',
  styleUrls: ['dismissible-hint.component.scss'],
  standalone: false,
})
export class CaDismissibleHint {
  isVisible: boolean = true;

  @Input()
  hint: string;

  @Input()
  dismissible: boolean = true;

  @Output()
  onDismiss = new EventEmitter();

  hideAndDismiss() {
    this.isVisible = false;
    this.onDismiss.emit();
  }
}
